/// <amd-module name="Wit/Common/WitSettingsViews/Components/CriteriaTable/CriteriaConstants" />
import { CoreFieldRefNames, FieldType } from "Wit/Common/Generated/Constants";
import { getLocalizedOperatorList, TextOperators, TextWithTextSupportOperators, WiqlOperators } from "Wit/Common/WiqlOperators";

export namespace CriteriaConstants {
    export const stringOperators: string[] = getLocalizedOperatorList([
        WiqlOperators.OperatorEqualTo,
        WiqlOperators.OperatorNotEqualTo,
        WiqlOperators.OperatorContains,
        WiqlOperators.OperatorNotContains
    ]);

    export const equalityOperators: string[] = getLocalizedOperatorList([WiqlOperators.OperatorEqualTo, WiqlOperators.OperatorNotEqualTo]);

    export const comparisonOperators: string[] = getLocalizedOperatorList([
        WiqlOperators.OperatorEqualTo,
        WiqlOperators.OperatorNotEqualTo,
        WiqlOperators.OperatorGreaterThan,
        WiqlOperators.OperatorLessThan,
        WiqlOperators.OperatorGreaterThanOrEqualTo,
        WiqlOperators.OperatorLessThanOrEqualTo
    ]);

    export const treePathOperators: string[] = getLocalizedOperatorList([
        WiqlOperators.OperatorEqualTo,
        WiqlOperators.OperatorNotEqualTo,
        WiqlOperators.OperatorUnder,
        WiqlOperators.OperatorNotUnder
    ]);

    export const textWithTextSupportOperators: string[] = getLocalizedOperatorList(TextWithTextSupportOperators);
    export const textOperators: string[] = getLocalizedOperatorList(TextOperators);
    export const maxCriteria = 5;

    export const supportedFieldTypes = new Set([
        FieldType.String,
        FieldType.Integer,
        FieldType.PlainText,
        FieldType.Double,
        FieldType.Boolean,
        //FieldType.DateTime, // excluding DateTime for now
    ]);

    export const notSupportedFieldReferenceNames = new Set([
        CoreFieldRefNames.Id.toLowerCase(),
        CoreFieldRefNames.Title.toLowerCase(),
        CoreFieldRefNames.AreaId.toLowerCase(),
        CoreFieldRefNames.IterationId.toLowerCase(),
        CoreFieldRefNames.Rev.toLowerCase(),
        CoreFieldRefNames.RevisedDate.toLowerCase(),
        CoreFieldRefNames.NodeName.toLowerCase(),
        CoreFieldRefNames.TeamProject.toLowerCase(),
        CoreFieldRefNames.Watermark.toLowerCase(),
        CoreFieldRefNames.ExternalLinkCount.toLowerCase(),
        CoreFieldRefNames.HyperLinkCount.toLowerCase(),
        CoreFieldRefNames.RelatedLinkCount.toLowerCase(),
        CoreFieldRefNames.AttachedFileCount.toLowerCase(),
        CoreFieldRefNames.AuthorizedAs.toLowerCase(),
        CoreFieldRefNames.AuthorizedDate.toLowerCase(),
        CoreFieldRefNames.LinkType.toLowerCase(),
        CoreFieldRefNames.Parent.toLowerCase()
    ]);
}
